import type { AotdDay } from "../../printsApi";

// What the print faces show, worked out from a day the same way the print files do
// (_print/pipeline: "+0.026s" under a minute, "+44m 52s" above, "aotd-3.7", "14 Oct 2026").

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const printDate = (iso: string) => {
  const d = new Date(iso);
  return `${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
};

export const raceOffset = (ms: number | null) => {
  if (ms == null) return "";
  if (ms < 60000) return `+${(ms / 1000).toFixed(3)}s`;
  const s = Math.round(ms / 1000);
  return `+${Math.floor(s / 60)}m ${s % 60}s`;
};

export const engineLabel = (v: string | null) => (v ? `aotd-${v}` : "");

/** The author's quote as the faces print it: trimmed, "" when there is none. */
export const printQuote = (day: Pick<AotdDay, "authorQuote">) => (day.authorQuote ?? "").trim();

/**
 * The card caption's size factor: 1 up to 45 characters (the limit since aotdsys-1.2), smaller
 * for an older, longer quote, never under 6 pt (0.8 of 7.5 pt). Same rule as the print template.
 */
export const quoteScale = (quote: string) => (quote.length > 45 ? Math.max(0.8, 45 / quote.length) : 1);

/** The AOTD_NUMBER badge tiers: these numbers get a box in the tier's colours. */
export const MILESTONES: Record<number, string> = {
  1: "ruby", 2: "paper", 10: "paper", 21: "rock", 45: "bronze", 69: "silver", 100: "silver",
  420: "gold", 450: "ruby", 500: "gold", 777: "gold", 1000: "emerald", 4500: "diamond",
};

/** The QR on posters and wall cards; the mockups show print 001. */
export const printQrUrl = (day: Pick<AotdDay, "number">) => `https://n450s.com/aotd/${day.number}?pst=001`;
